import {REACT_APP_API_HOST} from "./config";

export const API_ENDPOINT = {
	root: `${REACT_APP_API_HOST}/`,
	fileDownload: `${REACT_APP_API_HOST}/files`,
	registerPayment: `${REACT_APP_API_HOST}/payments/{0}/register?returnUrl={1}&externalId={2}&plates={3}`,
	invoices: `${REACT_APP_API_HOST}/permits/{0}/invoice/{1}`,
	errorLogging: `${REACT_APP_API_HOST}/logging/ui`,
}
